// extracted by mini-css-extract-plugin
module.exports = {"styles":"styles___2joen","grid1":"grid1___K2aDr","grid2":"grid2___3VGU8"};